import type * as React from "react";

export type BadgeTone = "open" | "neutral" | "outline";

const TONES: Record<BadgeTone, React.CSSProperties> = {
	open: {
		background: "var(--status-open-bg)",
		color: "var(--status-open-fg)",
	},
	neutral: {
		background: "var(--surface-elevated)",
		color: "var(--content-primary)",
	},
	outline: {
		background: "var(--surface-default)",
		color: "var(--content-primary)",
		border: "1px solid var(--border-strong)",
	},
};

type Props = {
	children: React.ReactNode;
	tone?: BadgeTone;
	size?: "sm" | "md";
	style?: React.CSSProperties;
};

export function Badge({
	children,
	tone = "neutral",
	size = "md",
	style,
}: Props) {
	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: 5,
				padding: size === "sm" ? "4px 9px" : "7px 13px",
				borderRadius: "var(--radius-pill)",
				fontSize: size === "sm" ? 11.5 : 12.5,
				fontWeight: 700,
				lineHeight: 1,
				whiteSpace: "nowrap",
				fontFamily: "var(--font-sans)",
				...TONES[tone],
				...style,
			}}
		>
			{children}
		</span>
	);
}
